import * as React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import { TextFieldComponent } from "components/ui-elements";
import { GetAllCategoriesAction } from "redux-container/faq/GetAllCategoriesRedux";
import { useDispatch } from "react-redux";
import ButtonComponent from "./../../../../components/ui-elements/button/ButtonComponent";
import { Box, IconButton, InputAdornment, Stack } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";

interface IFaqCategoryEditDialogProps {
  open: any;
  handleClose: () => any;
  editCategory: any;
  handleInputChange: (e: any) => void;
  categoryId: any;
  handleResetCategoryField: () => void;
  auditForCategoryNameUpdate: (newValue: string) => void;
}
const actionDispatch = (dispatch: any) => {
  return {
    editCategory: (id: any, data: any) =>
      dispatch(GetAllCategoriesAction.putCategoryRequest(id, data)),
  };
};

const FaqCategoryEditDialog = (props: IFaqCategoryEditDialogProps) => {
  const { editCategory } = actionDispatch(useDispatch());
  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
  };
  const handleUpadteCategoryName = () => {
    const reqBody = {
      name: props.editCategory,
    };

    editCategory(props.categoryId, reqBody);
    props.auditForCategoryNameUpdate(props.editCategory);
    props.handleClose();
  };

  return (
    <div>
      <Dialog
        open={props.open}
        onClose={handleClose}
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              maxWidth: "483px",
            },
          },
        }}
      >
        <DialogTitle>Edit Category</DialogTitle>
        <Box pt={2} px={2}>
          <TextFieldComponent
            margin="dense"
            id="name"
            fullWidth
            name="categoryName"
            variant="outlined"
            label="Category"
            value={props.editCategory}
            onChange={props.handleInputChange}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  {props.editCategory ? (
                    <IconButton onClick={props.handleResetCategoryField}>
                      <ClearIcon />
                    </IconButton>
                  ) : (
                    ""
                  )}
                </InputAdornment>
              ),
            }}
          />
        </Box>
        <Box p={2}>
          <Stack spacing="1rem" justifyContent={"flex-end"}>
            <ButtonComponent onClick={props.handleClose}>
              Cancel
            </ButtonComponent>
            <ButtonComponent
              variant="contained"
              onClick={handleUpadteCategoryName}
            >
              Save Changes
            </ButtonComponent>
          </Stack>
        </Box>
      </Dialog>
    </div>
  );
};

export default FaqCategoryEditDialog;
